// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3xEgW","topBottomGutter":"Layout_topBottomGutter__GNeZ7"};